import React from 'react';
import { userRoutes } from './User';
import { UserLayout } from '../layouts';

export const routes = () => {
  return [
    {
      element: <UserLayout/>,
      children: [...userRoutes()],
    },
    // {
    //   path: "*",
    //   element: <NotFound />,
    // },
  ];
};